function bodyTopPadding(){
    let topPadding = $('.main-header__sticky-wrapper').height();
    $('body').css('padding-top', topPadding + 'px');
}
$(document).ready(function(){
    bodyTopPadding();
});
$(window).on('resize orientationchange', function(){
    bodyTopPadding();
});